import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
import './assets/scss/main.scss'
import './assets/scss/_variables.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBullhorn, faSync, faQuestion, faEye, faSpinner, faTimesCircle, faMicrophone, faMicrophoneSlash, faClock, faCircle, faUserMd, faCrosshairs, faChevronRight, faChevronLeft, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(BootstrapVue)
library.add(faBullhorn, faSync, faQuestion, faEye, faSpinner, faTimesCircle, faMicrophone, faMicrophoneSlash, faClock, faCircle, faUserMd, faCrosshairs, faChevronRight, faChevronLeft, faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)

try {
  // TODO: Hacky Patch Due To jQuery Differing Versions
  if (window.location.hostname.indexOf('ui') !== -1) {
    window.$ = window.jQuery = require('jquery')
    window.Popper = require('popper.js').default
    require('bootstrap')
  }
} catch (e) {}
